import { get, post } from 'common/apiClient';

export type NachMasterLevelConfigPagedList<T> = {
  noOfRecords: number;
  currentPageIndex?: number;
  pageSize?: number;
  data: T[];
};

type DashboardModel<T> = {
  data: T[];
  noOfRecords: number;
  currentPageIndex?: number;
};

export type ResponseResource<T> = {
  responseCode: number;
  message: string;
  status: string;
  data: T;
};

export type NachMasterLevelConfigPagedResponse<T> = {
  responseCode: number;
  message: string;
  status: string;
  data: NachMasterLevelConfigPagedList<T>;
};

export interface NachWebhookDashboardResponse {
  sourceId: string;
  sourceApplicationName: string;
  statusId: number;
  status: string;
}

export type NachWebhookDashboardRequestPayload = {
  status?: string;
  sourceId?: string;
  sourceApplicationName?: string;
  statusId?: number;
  configURL?: string;
  active?: boolean;
  isActive?: boolean;
  userId?: number;
  pageNo?: number;
  statusConfigId?: number;
  sourceConfigId?: number;
  statusIdList?: number[];
};

export type MandateLinkDataType = {
  id: string;
  accountName?: string;
  mobileNumber: string;
  emailId: string;
  customerName: string;
};
export type MandateLinkFormType = {
  key?: string;
  loanTenor: string;
  cIFId: string;
  loanAmount: number | string;
  MandateAmount?: number;
  loanType?: string;
  maxBillingAmount?: string | number;
};
export type MandateLinkPayload = MandateLinkFormType &
  MandateLinkFormType & {
    loanNo: string;
    mandateStatus?: 'NEW_RECORD' | 'ALREADY_EXISTS' | string;
    mandateId: number;
    cIFId: string;
    autoPayLoanTypeEnable?: boolean;
  };

export type BankMasterFormPayloadType = {
  BankName: string;
  IFSCCode: string;
  AccountType: string;
  AccountNumber: string;
  NachType: string;
  AccountHolderName: string;
  BankId: string;
  Status?: string;
};

export type NachDashboardFilterPayload = {
  key?: string;
  LanNumber?: string;
  MerchantId?: string;
  PaymentDateFrom?: string;
  PaymentDateTo?: string;
  PaymentReferenceNo?: string;
  PaymentRequestId?: number;
  To?: string;
  SourceApplicationName?: string;
  RequestPurpose?: string;
  PaymentPurpose?: string;
  Status?: string;
  RequestStatus?: string;
  Username?: string;
  PageNo?: number;
  PageSize?: number;
  IsExtract?: boolean;
};

export type MandateLogDetailsType = {
  LogID: number;
  MandateID: number;
  Event: string;
  IsActive: boolean;
  CreatedBy: string;
  CreatedOn: string;
  ModifiedBy: string;
  ModifiedOn: string;
};
export type MandateApproveTypes = {
  MandateID: string;
  LoanNumber: string;
  SourceApplicationName: string;
  DisbursementCompleted?: string;
};

export type NachListData = {
  MandateRequestID: string;
  LoanNo: string;
  LoanType: string;
  MandateType: string;
  SourceApplicationName: string;
  GatewayName: string;
  RequestStatus: string;
  BankName: string;
  AccountNo: string;
  IFSCCode: string;
  MandateAmount: number;
  Mode: string;
  PaymentID: number;
  MandateStatus: string;
  VerificationReason: string;
  RequestDate: string;
  MandateStartDate: string;
  MandateEndDate: string;
  UMRNo: string;
  ByAgent: string;
  MandateRemark: String;
  statusDiscription: String;
};
export type FilterPayload = {
  isExtract?: boolean | null;
  pageSize?: any;
  pageNo?: any;
  username?: string | null;
  lanNumber?: string | null;
  mandateId?: number;
  GatewayName?: string | null;
  mandateStatus?: string;
  RequestStatus?: string;
  fromDate?: string | null;
  bankName?: string | null;
  paymentId?: string | null;
  toDate?: string | null;
  sourceApplicationName?: string | null;
  umrNo?: string | null;
  mandateType?: string | null;
};
export type NachPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: NachListData[];
};

// export type NachPagedResponse = {
//   data: NachPagedList;
// };
export type AuditLog = {
  LANumber: string;
  Event: string;
  EventDateTime: string;
  ErrorDescription: string;
  JsonFormate: string;
  JsonResult: string;
};
export type AuditResponse = {
  data: MandateLogDetailsType[];
};
export type NachUserAndBankDataPayload = {
  lanNum: string;
  cif: string;
  loanAmount: number;
  mandateAmount: number;
  tenure: string;
  userDetails: {
    username: string;
    email_id: string;
    relationship: string;
    mobileNum: string;
  };
  bankDetails?: BankDetailsPayload[];
  isAutopay: number;
  loantype: string;
  vpa?: string;
  sourceId: string;
  createdBy: number;
  nachId: number;
  maxBillingAmount: number;
  isApi: boolean;
};
export type BankDetailsPayload = {
  bankName?: string;
  accountNo?: string;
  accountType?: string;
  ifscCode?: string;
  branchName?: string;
  nachtype?: 0 | 1 | 2 | 3;
  isEditable: boolean;
  accountHolderName?: string;
  bankCode?: string;
};

type Response<T> = {
  responseCode?: string | number;
  message?: string;
  status?: string;
  data?: T;
};

export type getNachLoanDetailsResponse = {
  status?: number | string;
  data: MandateLinkPayload[];
  message?: string;
};

export type getNachMasterLevelDataType = {
  message: string;
  isAutoPay: string;
  nachId: number;
};

type getNachBankDetailsDataType = [
  {
    bankName: string;
  }
];
type validateUpiResponseDataType = {
  validate?: boolean;
  userName?: string;
  valid?: boolean;
};

export type nachBankDetailType = {
  bankName?: string;
  ifsc?: string;
  accountType?: string;
  accountNumber?: string;
  editable: boolean;
  branchName: string;
  nachtype: string;
  accountHolderName?: string;
  bankCode?: string;
};

export type getNachMandateDetailsResponseData = {
  cif: string;
  isActive: boolean;
  isAutoPay: boolean;
  laNumber: string;
  loanAmount: number;
  mandateAmount: number;
  nachId: number;
  sourceId: string;
  status: string;
  tenure: string;
  loanType: string;
  finalMode: string;
  nachUserDetails: {
    customerName: string;
    emailId: string;
    applicantType: string;
    mobileNumber: string;
    createdOn: Date;
    expiryDate: Date;
  };
  maxBillingAmount: number;
  nachBankDetails?: nachBankDetailType[];
  custEMail: string;
  phoneNumber: string;
};
type setUpAutoPayPayload = {
  mandateId: number;
  amount: number;
  vpa?: string;
  type: string;
  maxBillAMount: number;
  accountNumber?: string;
  ifsc?: string;
  accountHolderName?: string;
  bankName?: string;
  branchName?: string;
  bankCode?: string;
};
type setUpAutoPayDataType = {
  merchantOrderId: string;
  orderId: string;
  state: string;
  redirectUrl?: string; // ✅ ADD THIS LINE
};

export type nachRequestType = {
  name: string;
  email: string;
  contact: string;
  method: 'emandate' | 'nach';
  mandateid: number;
  nachtype: 'enach' | 'pnach';
  auth_type?: 'netbanking' | 'physical' | string;
  amount: number;
  expire_at: number;
  bankName: string;
  bank_account: {
    beneficiary_name: string;
    account_number: string;
    account_type: string;
    ifsc_code: string;
  };
  bankCode: string;
  branchName: string;
  fail_existing: 0 | 1;
  max_amount?: number;
};
export type waitingRequestType = {
  mandateId: number;
  orderId: string | undefined;
};
export type nachDataType = {
  custid: string;
  orderid: string;
  prefilled_form?: string;
};
type getOrderStatusRequestType = {
  orderId: string;
  mandateId: number;
  loggedInUserId: number;
};

type cancelMandateLinkType = {
  mandateId: number;
  loggedInUserId: number;
};
export type NachAuditLogType = {
  requestId: number;
  mandateId: number;
  mandateRequestJson: string;
  requestDate: string;
  type: string;
  mandateResponseJson: string;
};
export type mandateLinkDataType = {
  TotalCount: number;
  MandateId: string;
  LANumber: string;
  LoanAmount: string;
  ShortLink: string;
  EmailSendTo: string;
  FromEmailID: string;
  EmailSentDate: string;
  EmailStatus: string;
  SMSTo: string;
  ContactNo: string;
  SMSSentDate: string;
  SMSStatus: string;
  CreatedBy: string;
};
export type mandateLinkPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: mandateLinkDataType[];
};
export type MandateLinkFilterPayload = {
  PageNo?: number;
  isExtract?: boolean;
  PageSize?: number;
  LANumber?: string;
  Username?: string;
  SourceApplicationName?: string;
  MandateId?: number;
  fromDate?: string;
  toDate?: string;
};

interface RazorpayStatusByPayment {
  paymentId: string;
  mandateId: string;
  nachtype: string;
}

export interface PresentmentDashboard {
  userName?: string;
  active?: boolean;
  amount?: number;
  batchNo?: number;
  corporateName?: string;
  corporateUserNo?: string;
  createdBy?: number;
  createdOn?: string; // ISO 8601 date string
  customerDebitAC?: string;
  customerMICR?: string;
  dateOfTxn?: string; // ISO 8601 date string
  debtorName?: string;
  ifsc?: string;
  loanType?: string;
  merchantOrderId?: string;
  merchantSubscriptionId?: string;
  notificationDate?: string; // ISO 8601 date string
  notifyResponseOrderID?: string;
  partnerBank?: string;
  preNotificationStatus?: string;
  presentmentFlag?: number;
  presentmentId?: number;
  presentmentSource?: string;
  presentmentStatus?:
  | 'COMPLETED'
  | 'NOTIFICATION_IN_PROGRESS'
  | 'NOTIFIED'
  | 'PENDING'
  | 'PRESENTMENT_FAILED'
  | 'REDMPTION_FAILED'
  | 'NOTIFY_FAILED';
  sourcingType?: string;
  transactionIDREF?: string;
  umrnNO?: string;
  uniqueReference?: string;
  errorCode?: string;
}
// export type mandateLinkPagedResponse = {
//   data: mandateLinkPagedList;
// };
type razorpayPaymentResponse = {};

export interface PresentmentFilterPaylaod {
  startDate?: string;
  endDate?: string;
  presentmentFlagId?: number;
  autopayFlaseFilterMsg?: 'COMPLETED' | 'HOLD' | 'PENDING_FOR_REDEMPTION' | 'NOTIFIED';
  listOfIds?: number[];
  presentmentId?: number;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
}
export interface PresentmentAuditLogResponse {
  presentmentLogsId: number;
  presentmentId: number;
  apiURL: string;
  merchantOrderId: string;
  requestData: string;
  responseData: string;
  remarks: string;
  createdOn: string;
}

export type MandateApproveFilterPayload = {
  isExtract?: boolean | null;
  pageSize?: any;
  pageNo?: any;
  username?: string | null;
  lanNumber?: string | null;
  mandateId?: number;
  mandateStatus?: string;
  successURL?: string;
  failureURL?: string;
  RequestStatus?: string;
  fromDate?: string | null;
  bankName?: string | null;
  paymentId?: string | null;
  toDate?: string | null;
  sourceApplicationName?: string;
  umrNo?: string | null;
  mandateType?: string | null;
};
export type MandateApprovePagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: MandateApproveListData[];
};

export type MandateApproveListData = {
  totalCount: number;
  mandateId: string;
  loanNo: string;
  loanType: string;
  sourceApplicationName: string;
  bankName: string;
  accountNo: string;
  ifscCode: string;
  mandateAmount: string;
  mode: string;
  paymentId: number;
  mandateStatus: number;
  requestDate: Date;
  mandateStartDate: number;
  mandateEndDate: string;
  umrNo: string;
  byAgent: string;
  mandateRemark: string;
  approvateMandateID: number;
  aproveMandateCreatedOn: Date;
  maxBillingAmount: number;
  accountHolderName: string;
};

export type MandateBulkUploadFilter = {
  bulkUploadFileId?: number;
  fileName?: string;
  status?: string;
  pageNo?: number;
  pageSize?: number;
  isExtract?: boolean;
  fromDate?: Date;
  toDate?: Date;
};

export type MandateBulkUploadPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  pageSize?: number;
  data: MandateBulkUploadList[];
};

export type MandateBulkUploadList = {
  key?: React.Key;
  bulkUploadRequestList: MandateBulkUploadRequest[];
  bulkUploadFileId?: number;
  fileName: string;
  totalRecord?: number;
  totalSuccessRecord?: number;
  totalFailedRecord?: number;
  uploadStatus?: string;
  userEmailId?: string;
  partnerId?: number;
  sourceId?: string;
  createdBy?: string;
  createdDate?: string;
};

export type MandateBulkUploadRequest = {
  key?: React.Key;
  bulkUploadFileId?: number;
  paymentRequestId?: number;
  loanNumber?: string;
  paymentPurpose?: string;
  amount?: number;
  accountName?: string;

  mobileNo?: string;
  applicantType?: string;
  Status?: string;
  ErrorMessage?: string;
  createdDate?: string;

  LANnumber?: string;
  CIF?: string;
  MaximumBillingAmount?: number;
  MandateAmount?: number;
  ContactNumber?: string;
  Name?: string;
  emailId?: string;
  relationshipWithAppliocant?: string;
  NACHtype?: string;
  isEditable?: boolean | string;
  accountNumber?: string | number;
  IFSCcode?: string;
  bankName?: string;
  AccountName?: string;
  AccountType?: string;
};

export type BulkUploadFileDownloadResponse = {
  bulkUploadRequestId: number;
  bulkUploadFileId?: number;
  mandateId: number;
  lanNumber: string;
  cif: string;
  maxBillingAmount: number;
  mandateAmount: number;
  name: string;
  contactNo: string;
  emailId: string;
  applicantType: string;
  nachType: string;
  accountNumber: number;
  ifsc: string;
  bankName: string;
  accountName: string;
  accountType: string;
  status: string;
  isEditable: boolean;
  requestStatus?: string;
  errorMessage?: string;
  createdDate?: string | undefined;
  editable: boolean | string;
};

export interface DownloadTriggerPayload {
  startDate: string | moment.Moment; // Allow string (formatted) or Moment object
  endDate: string | moment.Moment;   // Allow string (formatted) or Moment object
  presentmentFlagId?: number;
  autopayFlaseFilterMsg?: 'COMPLETED' | 'HOLD' | 'PENDING_FOR_REDEMPTION' | 'NOTIFIED' | string;
  timestamp: number; // To ensure useEffect always detects a change
  currentActiveTabKey: number; // To identify which tab initiated the download
  autopayFalseCurrentTab?: string
  // Add any other filter properties that might be passed for download
  // e.g., if you have other dynamic filters like LoanType, etc.
}
export type BulkUploadFileResponse = {
  data: BulkUploadFileDownloadResponse[];
};

export type SelectResponse = {
  data: SelectList[];
};

export type SelectList = {
  statusId: number;
  status: string;
  description: string;
};

export type ifscResponse = {
  responseCode: number;
  message: string;
  status: string;
  data: {
    bankName: string;
    bankCode: string;
    branchCode: string;
    branchName: string;
    city: string;
    micr: string;
    ifsc: string;
  };
};



export type ifscRequestBody = {
  ifsc: string;
};

export const getMandateStatus = (payload?: NachWebhookDashboardRequestPayload) =>
  post<NachMasterLevelConfigPagedResponse<NachWebhookDashboardResponse>>(
    '/nachmodule/getMandateStatus',
    payload
  );

export const getMstSourceMapping = (payload?: NachWebhookDashboardRequestPayload) =>
  post<NachMasterLevelConfigPagedResponse<NachWebhookDashboardResponse>>(
    '/nachmodule/getMstSourceMapping',
    payload
  );

export const getSourceUrlMapping = (payload?: NachWebhookDashboardRequestPayload) =>
  post<ResponseResource<DashboardModel<NachWebhookDashboardResponse>>>(
    '/nachmodule/getSourceUrlMapping',
    payload
  );

export const getSourceMapping = (payload?: NachWebhookDashboardRequestPayload) =>
  post<ResponseResource<DashboardModel<NachWebhookDashboardResponse>>>(
    '/nachmodule/getSourceMapping',
    payload
  );

export const saveSourceConfigURLMapping = (payload?: NachWebhookDashboardRequestPayload) =>
  post<any>('/nachmodule/saveSourceConfigURLMapping', payload);

export const updateURLStatusConfigMapping = (payload?: NachWebhookDashboardRequestPayload) =>
  post<any>('/nachmodule/updateURLStatusConfigMapping', payload);

export const updateSourceConfigURLMapping = (payload?: NachWebhookDashboardRequestPayload) =>
  post<any>('/nachmodule/updateSourceConfigURLMapping', payload);

export const getNachLoanDetails = (payload?: { lanNumber: string }) =>
  post<getNachLoanDetailsResponse>('/nachmodule/getNachLoanDetails', payload);

export const getNachBankDetails = (payload?: { nachId: number }) =>
  post<Response<getNachBankDetailsDataType>>('/nachmodule/getNachBankDetails', payload);

export const createNachMandateLink = (payload?: NachUserAndBankDataPayload) =>
  post<Response<any>>('/nachmodule/createNachMandateLink', payload);

export const cancelMandateLink = (payload?: cancelMandateLinkType) =>
  post<Response<any>>('/nachmodule/cancelMandateLink', payload);

export const getNachMasterLevelDetails = (payload?: { sourceId: string }) =>
  post<Response<getNachMasterLevelDataType>>('/nachmodule/getNachMasterLevel', payload);

export const validateUpi = (payload?: { vpa: string; mandateId: string; type: string }) =>
  post<Response<validateUpiResponseDataType>>('/nachmodule/validateUpi', payload);

export const getOrderStatusDetails = (payload?: getOrderStatusRequestType) =>
  post<Response<any>>('/nachmodule/getOrderStatus', payload);

export const getRazorpayStatusByPayment = (payload?: RazorpayStatusByPayment) =>
  post<Response<any>>('/nachmodule/razorpay/payment', payload);

export const setUpAutoPay = (payload?: setUpAutoPayPayload) =>
  post<Response<setUpAutoPayDataType>>('/nachmodule/setUpAutoPay', payload);

export const getNachMandateDetails = (payload?: {
  mandateId: number;
  startDate: string;
  endDate: string;
}) =>
  post<Response<getNachMandateDetailsResponseData>>('/nachmodule/getNachMandateDetails', payload);

export const razorpayNachSetup = (payload?: nachRequestType) =>
  post<Response<nachDataType>>('/nachmodule/razorpay', payload);

export const waitingRazorpayOrder = (payload?: waitingRequestType) =>
  post<Response<nachDataType>>('/nachmodule/razorpay/waitingRazorpayOrder', payload);

export const razorpayOrder = (payload?: {}) =>
  post<razorpayPaymentResponse>('/nachmodule/razorpay/order', payload);

export const razorpayPayment = (payload?: {}) =>
  get<razorpayPaymentResponse>('/nachmodule/razorpay/payment' + payload);

export const razorpayCustomer = (payload?: {}) =>
  get<razorpayPaymentResponse>('/nachmodule/razorpay/customer' + payload);

export const getNachList = (payload?: FilterPayload) =>
  post<Response<NachPagedList>>('/nachmodule/getNachDashboard', payload);

export const getMandateApproveList = (payload?: MandateApproveFilterPayload) =>
  post<Response<MandateApprovePagedList>>('/nachmodule/getNewNachDashboard', payload);

export const getMandateBulkUploadDashboard = (payload?: MandateBulkUploadFilter) =>
  post<Response<MandateBulkUploadPagedList>>('/nachmodule/getMandateBulkUploadDashboard', payload);

export const getNachAuditLog = (payload: { mandateId: number }) =>
  post<Response<NachAuditLogType[]>>('/nachmodule/viewAuditTrail', payload);

export const getMandateLinkDashboard = (payload?: MandateLinkFilterPayload) =>
  post<Response<mandateLinkPagedList>>('/nachmodule/getMandateLinkDashboard', payload);
export const getMandateStatusList = () =>
  post<Response<{ data: [] }>>('/nachmodule/getMandateStatusList', {});

export const approveNachMandate = (payload: { mandateId: number; umrNo?: string }) =>
  post<Response<null>>('/nachmodule/createMandate', payload);

export const uploadPresentmentUrl = import.meta.env.VITE_NACH_URL + '/nachmodule/uploadPresentment';

export const uploadMandateApprove =
  import.meta.env.VITE_NACH_URL + '/nachmodule/uploadFailedNachLsit';

export const uploadMandateApproveBulk =
  import.meta.env.VITE_NACH_URL + '/nachmodule/bulkUploadMandate';

// export const presentmentDashboardFilter = (payload: PresentmentFilterPaylaod) =>
//   post<Response<PresentmentDashboard[]>>('/nachmodule/presentmentDashboardFilter', payload);

export const presentmentDashboardFilter = (payload: PresentmentFilterPaylaod) =>
  post<Response<PresentmentPagedList>>('/nachmodule/presentmentDashboardFilter', payload);

export const presentmentDashboardAutopayFalseFilter = (payload: PresentmentFilterPaylaod) =>
  post<Response<PresentmentPagedList>>(
    '/nachmodule/presentmentDashboardAutopayFalseFilter',
    payload
  );

export const presentmentDashboardAutopayFalseFilterBulkUpload = (payload: PresentmentFilterPaylaod) =>
  post<Response<PresentmentPagedList>>(
    '/nachmodule/presentmentDashboardAutopayFalseFilter',
    payload
  );
export const getDashboardFilterAutpayFalseData = (payload: PresentmentFilterPaylaod) =>
  post<Response<PresentmentPagedList>>('/nachmodule/getDashboardFilterAutpayData', payload);

export const getDashboardFilterAutpayPrsentmentPendingAndCompletedData = (
  payload: PresentmentFilterPaylaod
) =>
  post<Response<PresentmentPagedList>>(
    '/nachmodule/getDashboardFilterAutpayPrsentmentPendingAndCompletedData',
    payload
  );

export const presentmentDashboardRedmption = (payload: PresentmentFilterPaylaod) =>
  post<Response<null>>('/nachmodule/presentmentDashboardRedmption', payload);

export const presentmentUpdateFailedToCompleteStatus = (payload: PresentmentFilterPaylaod) =>
  post<Response<null>>('/nachmodule/presentmentUpdateFailedToCompleteStatus', payload);

export const MandateApproveUpdateFailedToCompleteStatus = (payload: MandateApproveFilterPayload) =>
  post<Response<null>>('/nachmodule/updateFailedStatusForCreateMandateByMandateId', payload);

export const getPresentmentLogByPresentmentId = (payload: PresentmentFilterPaylaod) =>
  post<Response<PresentmentAuditLogResponse[]>>(
    '/nachmodule/getPresentmentLogByPresentmentId',
    payload,
    false
  );

export const getBulkUploadStatus = () =>
  post<SelectResponse>('/nachmodule/getMandateCreationBulkUploadStatus', {
    headers: {
      'Content-Type': 'application/json',
    },
  });

export const getExportFileData = (payload?: MandateBulkUploadFilter) =>
  post<BulkUploadFileResponse>('/nachmodule/geExportFileData', payload);

export const getBankBranchMaster = (payload?: ifscRequestBody) =>
  post<ifscResponse>('/nachmodule/getBankBranchMaster', payload);

// export const uploadPresentment = (payload: PresentmentFilterPaylaod) =>
//   post<Response<null>>('/nachmodule/uploadPresentment', payload);

// ------------------------getMandateStatus presentmentDashboardRedmption
//  ------------ not usable --------------
// ----------------------------------------

export const getAuditLog = (paymentRequestId: number, IsExtract: boolean) =>
  get<AuditResponse>(
    '/dashboardmodule/getAuditLog?paymentRequestId=' + paymentRequestId + '&isExtract=' + IsExtract
  );

export type UpdateMandateDatesResponse = {
  message: string;
  startDate: string;
  status: 'SUCCESS' | 'ERROR';
};

export type UpdateMandateDatesPayload = {
  paymentType: string;
  mandateId: number;
};

export const updateMandateDates = (payload: UpdateMandateDatesPayload) => {
  // Convert the payload object into an array of [key, string-value] pairs
  const queryParamsArray = Object.entries(payload).map(([key, value]) => [
    key,
    String(value) // Explicitly convert number values to strings
  ]);

  // URLSearchParams now correctly accepts the string[][] format
  const queryString = new URLSearchParams(queryParamsArray).toString();

  // Append the generated query string to the URL
  return get<Response<UpdateMandateDatesResponse>>(`/nachmodule/updateMandateDates?${queryString}`);
};

export type PresentmentPagedList = {
  noOfRecords: number;
  currentPageIndex?: number;
  data: PresentmentDashboard[];
};
